export const DASHBOARD_BALANCE_LOADING_ID = "dashboard-balance-loading";
export const PUBLIC_BOTS_LOADING_ID = "public-bots-loading";
export const NOTIFICATIONS_COUNT_ID = "notifications-count";
export const DISPLAY_CURRENCY_TOGGLE_ID = "display-currency-toggle";
export const DASHBOARD_TRADE_GRID_ID = "dashboard-trade-grid";
export const MOBILE_DASHBOARD_BALANCE_ID = "mobile-dashboard-balance";
export const NOTIFICATIONS_LIST_ID = "notifications-list";
export const BOTTOM_DRAWER_CONTENT_ID = "bottom-drawer-content";
export const USER_AVATAR_TRIGGER_ID = "user-avatar-trigger";
export const USER_LOGOUT_BUTTON_ID = "user-logout-button";
export const NOTIFICATIONS_TRIGGER_ID = "notifications-trigger";
export const WORKSPACE_SWITCH_ID = "workspace-switch";
export const DARK_MODE_TOGGLE_ID = "dark-mode-toggle";
export const SIDER_MENU_ID = "sider-menu";
export const NEW_LOOK_TOGGLE_ID = "new-look-toggle";
export const MOBILE_MENU_TRIGGER_ID = "mobile-menu-trigger";
export const SPARKLINE_DOT_ID = "sparkline-dot";
export const SPARKLINE_LINE_ID = "sparkline-line";
export const TRY_NEW_LOOK_BUTTON_ID = "try-new-look-button";
export const USER_AVATAR_EMAIL_ID = "user-avatar-email";
export const PAGE_TITLE_ID = "page-title";

export const CREATE_ACCOUNT_EXCHANGE_CARD_ID = "create-account-exchange-card";

export const CREATE_ACCOUNT_SUB_EXCHANGE_CHECKBOX_ID = "sub-exchange-checkbox";
export const CREATE_ACCOUNT_ACCOUNT_NAME_ID = "account-name";
export const CREATE_ACCOUNT_API_KEY_ID = "api-key";
export const CREATE_ACCOUNT_API_SECRET_ID = "api-secret";
export const CREATE_ACCOUNT_API_PASSPHRASE_ID = "api-passphrase";
export const CREATE_ACCOUNT_COPY_IPS_BUTTON_ID = "copy-ips-button";
export const CREATE_ACCOUNT_USE_API_KEYS_ID = "create-account-use-api-keys";
export const CREATE_ACCOUNT_USE_QUICK_CONNECT_ID =
  "create-account-use-quick-connect";
export const CREATE_ACCOUNT_SHOW_ALL_IPS_ID = "create-account-show-all-ips";
export const CREATE_ACCOUNT_CONNECT_EXCHANGE_BUTTON_ID =
  "connect-exchange-button";
export const CREATE_ACCOUNT_SUCCESS_MESSAGE_ID =
  "create-account-success-message";
export const CREATE_ACCOUNT_BINANCE_SUB_EXCHANGES = [
  "Binance",
  "Binance Futures",
  "Binance Coin-Futures",
];
export const CREATE_ACCOUNT_KUCOIN_SUB_EXCHANGES = ["KuCoin", "KuCoin Futures"];
export const CREATE_ACCOUNT_BYBIT_SUB_EXCHANGES = [
  "ByBit Spot",
  "ByBit USDT",
  "ByBit",
  "ByBit Spot Margin",
];
export const CREATE_ACCOUNT_BITGET_SUB_EXCHANGES = [
  "Bitget Spot",
  "Bitget Futures",
  "Bitget Inverse",
];
export const QUICK_CONNECT_SUBMIT_BUTTON_ID = "quick-connect-submit-button";

export const ACCOUNT_EXPOSURE_CARD_ID = "account-exposure-card";
export const ACCOUNT_EXPOSURE_TITLE_ID = "account-exposure-title";
export const ACCOUNT_EXPOSURE_CORNIX_TOGGLE_ID =
  "account-exposure-cornix-toggle";
export const ACCOUNT_EXPOSURE_CORNIX_SECTION_ID =
  "account-exposure-cornix-section";
export const ACCOUNT_EXPOSURE_CORNIX_SECTION_TITLE_ID =
  "account-exposure-cornix-section-title";
export const ACCOUNT_EXPOSURE_TILE_ID = "account-exposure-tile";
export const ACCOUNT_EXPOSURE_TILE_LABEL_ID = "account-exposure-tile-label";
export const ACCOUNT_EXPOSURE_TILE_USD_VALUE_ID =
  "account-exposure-tile-usd-value";
export const ACCOUNT_EXPOSURE_TILE_BTC_VALUE_ID =
  "account-exposure-tile-btc-value";
export const ACCOUNT_EXPOSURE_EXCHANGE_SECTION_ID = "exchange";
export const ACCOUNT_EXPOSURE_CORNIX_CURRENT_SECTION_ID = "cornix-current";
export const ACCOUNT_EXPOSURE_CORNIX_POTENTIAL_SECTION_ID = "cornix-potential";

export const DASHBOARD_PAGE_ID = "dashboard-page";
export const PULL_TO_REFRESH_ID = "pull-to-refresh";
export const MCP_PAGE_ID = "mcp-page";
export const MCP_COPY_BUTTON_ID = "mcp-copy-button";
export const FINANCE_PAGE_ID = "finance-page";
export const STATS_AND_CHART_CARD_ID = "stats-and-chart-card";
export const LINE_CHART_ID = "line-chart";
export const BAR_CHART_ID = "bar-chart";
export const CHART_TOOLTIP_ID = "chart-tooltip";

export const getAuthSocialLoginButtonId = (platform: number): string =>
  `auth-social-login-${platform}`;

export const AUTH_LOGIN_EMAIL_INPUT_ID = "auth-login-email-input";
export const AUTH_LOGIN_PASSWORD_INPUT_ID = "auth-login-password-input";
export const AUTH_LOGIN_SUBMIT_BUTTON_ID = "auth-login-submit-button";
export const AUTH_REGISTER_LINK_ID = "auth-register-link";
export const AUTH_FORGOT_PASSWORD_LINK_ID = "auth-forgot-password-link";

export const AUTH_REGISTER_FIRST_NAME_INPUT_ID =
  "auth-register-first-name-input";
export const AUTH_REGISTER_LAST_NAME_INPUT_ID = "auth-register-last-name-input";
export const AUTH_REGISTER_EMAIL_INPUT_ID = "auth-register-email-input";
export const AUTH_REGISTER_PASSWORD_INPUT_ID = "auth-register-password-input";
export const AUTH_REGISTER_SUBMIT_BUTTON_ID = "auth-register-submit-button";
export const AUTH_SECURITY_SECTION_ID = "auth-security-section";
export const AUTH_SECURITY_TIP_ICON_ID = "auth-security-tip-icon";
export const AUTH_LOGIN_LINK_ID = "auth-login-link";

export const AUTH_FORGOT_PASSWORD_EMAIL_INPUT_ID =
  "auth-forgot-password-email-input";
export const AUTH_FORGOT_PASSWORD_SUBMIT_BUTTON_ID =
  "auth-forgot-password-submit-button";
export const AUTH_BACK_TO_LOGIN_BUTTON_ID = "auth-back-to-login-button";

export const AUTH_VERIFICATION_CODE_INPUT_ID = "auth-verification-code-input";
export const AUTH_VERIFICATION_EMAIL_ID = "auth-verification-email";
export const AUTH_RESEND_EMAIL_ID = "auth-resend-email";
export const AUTH_VERIFICATION_CODE_SUBMIT_BUTTON_ID =
  "auth-verification-code-submit-button";

export const GROUP_CARD_ID = "group-card";
export const PUBLIC_BOT_CARD_ID = "public-bot-card";
export const PUBLIC_BOT_TOTAL_PROFIT_ID = "public-bot-total-profit";
export const ONBOARDING_SKIP_CREATE_BOT_BUTTON_ID =
  "onboarding-skip-create-bot-button";
export const ONBOARDING_CONFIRM_SKIP_BUTTON_ID =
  "onboarding-confirm-skip-button";
export const ONBOARDING_CANCEL_SKIP_BUTTON_ID = "onboarding-cancel-skip-button";
export const ONBOARDING_SKIP_MODAL_TITLE_ID = "onboarding-skip-modal-title";
export const ONBOARDING_SKIP_MODAL_BODY_ID = "onboarding-skip-modal-body";
export const ONBOARDING_SKIP_MODAL_ID = "onboarding-skip-modal";
export const ONBOARDING_MARKETPLACE_PROMPT_ID = "onboarding-marketplace-prompt";

export const CREATE_BOT_BUTTON_ID = "create-bot-button";
export const MY_BOTS_CREATE_BOT_BUTTON_ID = "my-bots-create-bot-button";
export const MY_BOTS_CREATE_SINGLE_BUTTON_ID = "my-bots-create-single-button";
export const MY_BOTS_BULK_CREATE_BUTTON_ID = "my-bots-bulk-create-button";
export const getCreateBotModalBotTypeId = (botType: string | number) =>
  `create-bot-modal-bot-type-${botType}`;
export const BOT_FORM_SAVE_BUTTON_ID = "bot-form-save-button";
export const BOT_FORM_REVIEW_BUTTON_ID = "bot-form-review-button";
export const BOT_FORM_PHONE_ACTION_ROW_ID = "bot-form-phone-action-row";
export const BOT_FORM_SUMMARY_WRAPPER_ID = "bot-form-summary-wrapper";
export const BOT_FORM_HELPERS_RAIL_ID = "bot-form-helpers-rail";
export const BOT_FORM_SUMMARY_ERROR_ID = "bot-form-summary-error";
export const getBotFormTabId = (tab: string) =>
  `bot-form-tab-${tab.replace(/\./g, "-")}`;
export const getBotFormRestoreButtonId = (tab: string) =>
  `bot-form-restore-${tab.replace(/\./g, "-")}-button`;
export const BOT_FORM_CONFIRM_BULK_EDIT_CONTINUE_BUTTON_ID =
  "bot-form-confirm-bulk-edit-continue-button";
export const BOT_FORM_CONFIRM_SAVE_BUTTON_ID = "bot-form-confirm-save-button";
export const BOT_ACTIONS_TRIGGER_ID = "bot-actions-trigger";
export const BOT_ACTION_VIEW_CLOSED_TRADES_ID = "bot-action-view-closed-trades";
export const BOT_PREVIEW_CARD_ID = "bot-preview-card";
export const BOT_PREVIEW_TRADES_SECTION_ID = "bot-preview-trades-section";
export const getDrawerTabId = (tab: string) =>
  `drawer-tab-${tab.toLowerCase().split(" ").join("-")}`;
export const getTableRowSelectCheckboxId = (rowId: string | number) =>
  `table-row-select-checkbox-${rowId}`;
export const getBulkActionButtonId = (action: string) =>
  `bulk-action-button-${action.toLowerCase().split(" ").join("-")}`;
export const BOT_FORM_ACCOUNT_SELECT_ID = "bot-form-account-select";
export const BOT_FORM_ACCOUNT_ERROR_ID = "bot-form-account-error";
export const BOT_FORM_NO_ACCOUNT_CARD_ID = "bot-form-no-account-card";
export const BOT_FORM_NO_ACCOUNT_CONNECT_ID = "bot-form-no-account-connect";
export const BOT_FORM_NO_ACCOUNT_SWITCH_WORKSPACE_ID =
  "bot-form-no-account-switch-workspace";
export const BOT_FORM_ADVANCED_SETTINGS_BUTTON_ID =
  "bot-form-advanced-settings-button";
export const BOT_FORM_ACCOUNTS_CLEAR_BUTTON_ID =
  "bot-form-accounts-clear-button";
export const getBotFormExchangeTagId = (exchangeTag: string) =>
  `bot-form-exchange-tag-${exchangeTag.toLowerCase()}`;
export const BOT_FORM_EXCHANGES_DROPDOWN_ID = "bot-form-exchanges-dropdown";
export const getBotFormExchangeDropdownOptionId = (exchange: string) =>
  `bot-form-exchange-dropdown-option-${exchange
    .toLowerCase()
    .split(" ")
    .join("-")}`;
export const AMOUNT_PER_TRADE_INPUT_ID = "amount-per-trade-input";
export const HEDGING_LONG_INPUT_ID = "hedging-long-input";
export const HEDGING_SHORT_INPUT_ID = "hedging-short-input";
export const HEDGING_RANGE_OPTION_ID = "hedging-range-option";
export const HEDGING_FIXED_OPTION_ID = "hedging-fixed-option";
export const HEDGING_RANGE_MIN_PRICE_INPUT_ID = "hedging-range-min-price-input";
export const HEDGING_RANGE_MAX_PRICE_INPUT_ID = "hedging-range-max-price-input";
export const HEDGING_RANGE_LOWER_LONG_INPUT_ID =
  "hedging-range-lower-long-input";
export const HEDGING_RANGE_LOWER_SHORT_INPUT_ID =
  "hedging-range-lower-short-input";
export const HEDGING_RANGE_UPPER_LONG_INPUT_ID =
  "hedging-range-upper-long-input";
export const HEDGING_RANGE_UPPER_SHORT_INPUT_ID =
  "hedging-range-upper-short-input";
export const HEDGING_TAB_OVERRIDE_BUTTON_ID = "hedging-tab-override-button";
export const HEDGING_STRATEGY_OVERRIDE_BUTTON_ID =
  "hedging-strategy-override-button";
export const STRATEGY_PRICE_DIFFERENCE_INPUT_ID =
  "strategy-price-difference-input";
export const ONBOARDING_GUIDED_DEMO_ID = "onboarding-guided-demo";
export const ONBOARDING_LIVE_PATH_ID = "onboarding-live-path";
export const ONBOARDING_CREATE_PRACTICE_ID = "onboarding-create-practice";
export const ONBOARDING_PREVIEW_BOT_ID = "onboarding-preview-bot";
export const ONBOARDING_BROWSE_BOTS_ID = "onboarding-browse-bots";
export const ONBOARDING_ACCOUNT_RADIO_ID = "onboarding-account-radio";
export const ONBOARDING_PRACTICE_ERROR_ID = "onboarding-practice-error";
export const ONBOARDING_BACK_ID = "onboarding-back";
export const ONBOARDING_INTENT_ID = "onboarding-intent";
export const ONBOARDING_DEMO_ACTION_ID = "onboarding-demo-action";
export const ONBOARDING_DEMO_RESULT_ID = "onboarding-demo-result";
export const ONBOARDING_INTENT_CONTINUE_ID = "onboarding-intent-continue";

export const ONBOARDING_CHANNEL_TAB_ID = "onboarding-channel-tab";

export const ONBOARDING_METHOD_NEXT_ID = "onboarding-method-next";
export const ONBOARDING_MODE_BACK_ID = "onboarding-mode-back";
export const ONBOARDING_WALKTHROUGH_BACK_ID = "onboarding-walkthrough-back";
export const ONBOARDING_MODE_CHOICE_ID = "onboarding-mode-choice";

export const ONBOARDING_PRACTICE_EXCHANGE_ID = "onboarding-practice-exchange";

export const ONBOARDING_SIGNALS_CONFIRM_ID = "onboarding-signals-confirm";

export const ONBOARDING_BOT_CONFIGURATION_ID = "onboarding-bot-configuration";
export const GROUP_CONFIGURATION_TRIGGER_ID = "group-configuration-trigger";
export const BOT_CONFIGURATION_SUMMARY_ID = "bot-configuration-summary";
export const BOT_CHART_COMPARE_ID = "bot-chart-compare";
export const BOT_CHART_COMPARISON_ID = "bot-chart-comparison";

export const ONBOARDING_SWITCH_MODE_ID = "onboarding-switch-mode";
export const ONBOARDING_CONNECT_CHANNEL_ID = "onboarding-connect-channel";
export const ONBOARDING_SETUP_ID = "onboarding-setup";
export const ONBOARDING_CONFIRM_CREATE_ID = "onboarding-confirm-create";
export const ONBOARDING_CUSTOMIZE_ID = "onboarding-customize";
export const ONBOARDING_CONFIRM_PANEL_ID = "onboarding-confirm-panel";
export const ONBOARDING_TELEGRAM_CODE_ID = "onboarding-telegram-code";
export const ONBOARDING_TELEGRAM_CONNECT_ID = "onboarding-telegram-connect";
export const ONBOARDING_DISCORD_OAUTH_ID = "onboarding-discord-oauth";
export const ONBOARDING_DISCORD_CHECK_ID = "onboarding-discord-check";
export const ONBOARDING_DEMO_CHART_ID = "onboarding-demo-chart";

export const BOT_FORM_NAME_INPUT_ID = "bot-form-name-input";
export const BOT_FORM_NAME_ERROR_ID = "bot-form-name-error";
export const BOT_FORM_SYMBOL_SELECT_ID = "bot-form-symbol-select";

export const BOT_FORM_FINISH_SETUP_ID = "bot-form-finish-setup";
export const BOT_FORM_TRADINGVIEW_DETAILS_ID = "bot-form-tradingview-details";
export const ONBOARDING_EXPLORE_ID = "onboarding-explore-platform";
export const ONBOARDING_CHANGE_PRACTICE_ID = "onboarding-change-practice";
export const ONBOARDING_SELECTED_PRACTICE_ID = "onboarding-selected-practice";

export const ONBOARDING_DEMO_PLAYBACK_ID = "onboarding-demo-playback";

export const ONBOARDING_CONTINUE_LIVE_ID = "onboarding-continue-live";
export const ONBOARDING_LEARN_METHOD_ID = "onboarding-learn-method";

export const STRATEGY_PRICE_SCALE_INPUT_ID = "strategy-price-scale-input";
export const STRATEGY_ORDER_COUNT_INPUT_ID = "strategy-order-count-input";
export const STRATEGY_ACTIVE_ORDER_COUNT_INPUT_ID =
  "strategy-active-order-count-input";
export const STRATEGY_FIRST_ENTRY_PERCENT_INPUT_ID =
  "strategy-first-entry-percent-input";
export const getDefaultOrderPercentInputId = (orderType: number | string) =>
  `default-order-percent-${orderType}`;

export const PAGE_TAB_ID = "page-tab";
export const PAGE_TABS_BAR_ID = "page-tabs-bar";
export const DRAWER_SCROLL_ID = "drawer-scroll";
export const DRAWER_COLLAPSED_BAR_ID = "drawer-collapsed-bar";
export const GROUP_PNL_PANEL_ID = "group-pnl-panel";
export const GROUP_PNL_HEADLINE_ID = "group-pnl-headline";
export const CHART_RANGES_ID = "chart-ranges";
export const CHART_RANGE_ID = "chart-range";
export const PNL_CHART_ID = "pnl-chart";
export const PNL_CHART_GUIDE_ID = "pnl-chart-guide";

export const PRICE_LADDER_ID = "price-ladder";

export const ALLOCATION_TOTAL_ID = "allocation-total";
export const PORTFOLIO_OVERVIEW_ID = "portfolio-overview";

export const TOP_SYMBOL_CHIP_ID = "top-symbol-chip";
export const TOP_SYMBOL_PRICE_LINE_ID = "top-symbol-price-line";
export const HEADER_BTC_TICKER_ID = "header-btc-ticker";

export const STAT_STRIP_ID = "stat-strip";
export const DASHBOARD_OVERVIEW_ID = "dashboard-overview";
export const DASHBOARD_PORTFOLIO_VALUE_ID = "dashboard-portfolio-value";
export const PHONE_SUMMARY_CARD_ID = "phone-summary-card";

export const DASHBOARD_TRADE_CARD_ID = "dashboard-trade-card";

export const MY_BOTS_LOADING_ID = "my-bots-loading";
export const MOBILE_ALLOCATION_ID = "mobile-allocation";

export const TRADE_CARD_QUANTITY_ID = "trade-card-quantity";

export const TRADE_CARD_ROW_ID = "trade-card-row";
export const TRADE_CARD_SIDE_ID = "trade-card-side";
export const BOTTOM_NAV_ITEM_ID = "bottom-nav-item";
export const TRADE_CARD_ACTIONS_ID = "trade-card-actions";
export const TRADE_CARD_EXPAND_ID = "trade-card-expand";
export const TRADE_CARD_DETAILS_ID = "trade-card-details";
export const TRADE_CARD_DETAIL_ID = "trade-card-detail";
export const TRADE_CARD_DETAILS_BUTTON_ID = "trade-card-details-button";
export const TRADE_CARD_SELECT_ID = "trade-card-select";
export const TRADE_CARD_LADDER_START_ID = "trade-card-ladder-start";
export const TRADE_CARD_LADDER_END_ID = "trade-card-ladder-end";
export const TRADE_CARD_STATUS_ID = "trade-card-status";
export const TRADE_CARD_ACCOUNT_ID = "trade-card-account";
export const TRADE_CARD_POSITION_ID = "trade-card-position";
export const TRADE_CARD_AGE_ID = "trade-card-age";
export const TRADE_CARD_TIME_ID = "trade-card-time";
export const TRADE_ORDERS_SECTION_ID = "trade-orders-section";
export const PHONE_BRAND_CHART_EMPTY_ID = "phone-brand-chart-empty";
export const PHONE_META_TAIL_ID = "phone-meta-tail";
export const WATCHLIST_CARD_ID = "watchlist-card";
export const TRADE_CARD_SOURCE_ID = "trade-card-source";
export const TRADE_CARD_FOOTER_ID = "trade-card-footer";
export const PHONE_CLOSED_PNL_TOGGLE_ID = "phone-closed-pnl-toggle";
export const PHONE_CLOSED_PNL_CHART_ID = "phone-closed-pnl-chart";
export const PHONE_TRADES_EXPORT_ID = "phone-trades-export";
export const PHONE_ASSET_ROW_ID = "phone-asset-row";
export const PHONE_ASSET_SPARK_ID = "phone-asset-spark";
export const NEW_LOOK_TRADES_CARDS_GRID_ID = "new-look-trades-cards-grid";
export const LAYOUT_SWITCH_OPTION_ID = "layout-switch-option";

export const DASHBOARD_ACCOUNT_ROW_ID = "dashboard-account-row";

export const SIGNAL_CARD_ROW_ID = "signal-card-row";
export const SIGNAL_CARD_SYMBOL_ID = "signal-card-symbol";
export const SIGNAL_CARD_POSITION_ID = "signal-card-position";
export const SIGNAL_CARD_FIGURE_ID = "signal-card-figure";
export const SIGNAL_CARD_PRICE_ID = "signal-card-price";
export const SIGNAL_CARD_FOLLOW_ID = "signal-card-follow";
export const SIGNAL_CARD_PROGRESS_ID = "signal-card-progress";
export const SIGNAL_CARD_ENTRIES_ID = "signal-card-entries";
export const SIGNAL_CARD_TAKE_PROFITS_ID = "signal-card-take-profits";
export const SIGNAL_CARD_FOOTER_ID = "signal-card-footer";
export const SIGNAL_CARD_EXPAND_ID = "signal-card-expand";
export const SIGNAL_CARD_ACTIONS_ID = "signal-card-actions";
export const SIGNAL_CARD_SELECT_ID = "signal-card-select";
export const SIGNAL_CARD_DETAILS_ID = "signal-card-details";
export const SIGNAL_CARD_DETAIL_ID = "signal-card-detail";
export const SIGNAL_CARD_EXCHANGE_ID = "signal-card-exchange";
export const SIGNAL_CARD_DETAILS_BUTTON_ID = "signal-card-details-button";
export const PHONE_SIGNALS_SORT_ID = "phone-signals-sort";

export const SCORE_BREAKDOWN_ID = "score-breakdown";
export const SCORE_SECTION_ID = "score-section";
export const SCORE_METRIC_ID = "score-metric";
export const SCORE_BADGE_ID = "score-badge";

export const BOT_RESULT_ID = "bot-result";
export const BOT_SPARK_ID = "bot-spark";

export const ACCOUNT_CARDS_GRID_ID = "account-cards-grid";
export const NEW_LOOK_ACCOUNT_CARD_ID = "new-look-account-card";
export const NEW_LOOK_COIN_ALLOCATION_ID = "new-look-coin-allocation";
export const NEW_LOOK_POSITION_CARD_ID = "new-look-position-card";
export const FILTERS_COLUMN_ID = "filters-column";
export const FILTERS_DRAWER_BUTTON_ID = "filters-drawer-button";
export const PRICE_LADDER_ZONE_ID = "price-ladder-zone";
export const PRICE_LADDER_MARKER_ID = "price-ladder-marker";
export const PRICE_LADDER_TICK_ID = "price-ladder-tick";
export const PRICE_LADDER_PRICE_ID = "price-ladder-price";
export const PRICE_LADDER_CHANGE_ID = "price-ladder-change";
export const PRICE_LADDER_LABEL_ID = "price-ladder-label";
export const PRICE_LADDER_FOCUS_ID = "price-ladder-focus";
export const PRICE_LADDER_CARD_ID = "price-ladder-card";
export const PRICE_LADDER_DETAILS_ID = "price-ladder-details";
export const PAGE_TAB_INDICATOR_ID = "page-tab-indicator";

export const BOT_FORM_FOLLOW_FUTURES_AS_SPOT_ID =
  "bot-form-follow-futures-as-spot";
export const BOT_FORM_FUTURES_AS_SPOT_NOTICE_ID =
  "bot-form-futures-as-spot-notice";
export const BOT_FORM_FUTURES_AS_SPOT_HELPER_ID =
  "bot-form-futures-as-spot-helper";
export const BOT_FORM_FUTURES_AS_SPOT_CONFIRMATION_ID =
  "bot-form-futures-as-spot-confirmation";

export const AMOUNT_PER_TRADE_TYPE_SELECT_ID = "amount-per-trade-type-select";

export const BOT_FORM_FUTURES_AS_SPOT_MANAGE_ID =
  "bot-form-futures-as-spot-manage";
export const BOT_FORM_NO_SIGNALS_SUGGESTION_ID =
  "bot-form-no-signals-suggestion";
export const BOT_FORM_BROWSE_GROUPS_ID = "bot-form-browse-groups";
export const BOT_FORM_RECOMMENDED_GROUP_ID = "bot-form-recommended-group";
export const BOT_FORM_RECOMMENDED_GROUP_PNL_ID =
  "bot-form-recommended-group-pnl";
export const BOT_FORM_GROUP_SELECT_ID = "bot-form-group-select";
export const ONBOARDING_SELECTED_GROUP_NAME_ID =
  "onboarding-selected-group-name";
